export default __webpack_public_path__ + "b6c12b50d8329ed0ba1ee6a0dcee1119.png";